import script from "./RcSeparator.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcSeparator.vue?vue&type=script&setup=true&lang=ts"

import "./RcSeparator.vue?vue&type=style&index=0&id=5e0f1787&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0f1787"]])

export default __exports__